import { z } from 'zod';
export const MAIL_VARIABLES = {
    'empfaenger.name': { label: 'Name des Empfängers', group: 'Allgemein', example: 'Erika Mustermann' },
    'firma.name': { label: 'Ihr Unternehmen', group: 'Allgemein', example: 'Musterfirma Service GmbH' },
    'firma.telefon': { label: 'Telefon Ihres Unternehmens', group: 'Allgemein', example: '0251 123456' },
    'firma.email': { label: 'E-Mail Ihres Unternehmens', group: 'Allgemein', example: 'service@musterfirma.example' },
    'firma.adresse': { label: 'Adresse Ihres Unternehmens', group: 'Allgemein', example: 'Musterstraße 1, 48167 Münster' },
    datum: { label: 'Heutiges Datum', group: 'Allgemein', example: '15.10.2026' },
    betreff: { label: 'Standardbetreff dieser Mail', group: 'Allgemein', example: '[T-000123] Neue Antwort: Drucker druckt nicht' },
    link: { label: 'Link (Adresse)', group: 'Allgemein', example: 'https://portal.example/portal/tickets/…' },
    schaltflaeche: { label: 'Schaltfläche zum Link', group: 'Allgemein', example: '[Schaltfläche]', block: true },
    nachricht: { label: 'Nachrichtentext (z. B. Antwort des Technikers)', group: 'Allgemein', example: 'Bitte starten Sie den Drucker einmal neu.', block: true },
    standardtext: { label: 'Standardtext dieser Mail', group: 'Allgemein', example: 'Hier steht der eingebaute Text dieser Mail.', block: true },
    signatur: { label: 'Signatur', group: 'Allgemein', example: '[Signatur]', block: true },
    'kunde.name': { label: 'Kunde (Firma oder Name)', group: 'Kunde', example: 'Beispiel AG' },
    'kunde.nummer': { label: 'Kundennummer', group: 'Kunde', example: 'K-000042' },
    'kunde.anrede': { label: 'Anrede des Kunden (Herr, Frau, Familie; leer bei Firmen)', group: 'Kunde', example: 'Frau' },
    'kunde.briefanrede': { label: 'Briefanrede (z. B. „Sehr geehrte Frau Muster“)', group: 'Kunde', example: 'Sehr geehrte Frau Muster' },
    'ansprechpartner.name': { label: 'Ansprechpartner', group: 'Kunde', example: 'Erika Mustermann' },
    'ansprechpartner.vorname': { label: 'Vorname Ansprechpartner', group: 'Kunde', example: 'Erika' },
    'ansprechpartner.nachname': { label: 'Nachname Ansprechpartner', group: 'Kunde', example: 'Mustermann' },
    'mitarbeiter.name': { label: 'Zuständiger Mitarbeiter (Bearbeiter/Techniker)', group: 'Mitarbeiter', example: 'Max Techniker' },
    'mitarbeiter.vorname': { label: 'Vorname zuständiger Mitarbeiter', group: 'Mitarbeiter', example: 'Max' },
    'absender.name': { label: 'Mitarbeiter, der geschrieben/ausgelöst hat', group: 'Mitarbeiter', example: 'Max Techniker' },
    'ticket.nummer': { label: 'Ticketnummer', group: 'Ticket', example: 'T-000123' },
    'ticket.betreff': { label: 'Betreff der Anfrage', group: 'Ticket', example: 'Drucker druckt nicht' },
    'ticket.status': { label: 'Status (Kundensicht)', group: 'Ticket', example: 'In Bearbeitung' },
    'ticket.bereich': { label: 'Bereich', group: 'Ticket', example: 'IT-Support' },
    'reparatur.nummer': { label: 'Reparaturnummer', group: 'Reparatur', example: 'R-000045' },
    'reparatur.geraet': { label: 'Gerät', group: 'Reparatur', example: 'Notebook Lenovo ThinkPad T14' },
    'reparatur.status': { label: 'Stand (Kundensicht)', group: 'Reparatur', example: 'In Reparatur' },
    'reparatur.ergebnis': { label: 'Ergebnis', group: 'Reparatur', example: 'repariert' },
    'kva.betrag': { label: 'Kostenvoranschlag brutto', group: 'Reparatur', example: '189,00 €' },
    'termin.titel': { label: 'Termin', group: 'Termin', example: 'Vor-Ort-Service' },
    'termin.zeit': { label: 'Datum und Uhrzeit', group: 'Termin', example: 'Mo., 19.10.2026, 09:00 bis 10:00 Uhr' },
    'termin.ort': { label: 'Ort', group: 'Termin', example: 'Musterstraße 1, Münster' },
    'termin.online': { label: 'Link zur Online-Besprechung', group: 'Termin', example: 'https://teams.microsoft.com/…' },
    code: { label: 'Einmalcode', group: 'Zugang', example: '482913' },
    gueltigkeit: { label: 'Gültigkeit des Links/Codes', group: 'Zugang', example: '72 Stunden' },
};
const GENERIC = '<p>Hallo {{empfaenger.name}},</p><p>{{standardtext}}</p><p>{{nachricht}}</p><p>{{schaltflaeche}}</p><p>{{signatur}}</p>';
const T = (paragraphs, extra = '') => `<p>Hallo {{empfaenger.name}},</p>${paragraphs.map((p) => `<p>${p}</p>`).join('')}${extra}<p>{{signatur}}</p>`;
const CUSTOMER_TICKET = ['Kunde', 'Mitarbeiter', 'Ticket'];
const CUSTOMER_REPAIR = ['Kunde', 'Mitarbeiter', 'Reparatur'];
const APPOINTMENT = ['Kunde', 'Mitarbeiter', 'Ticket', 'Termin'];
const TERMIN_DETAILS = '<p>Termin: {{termin.titel}}<br>Zeit: {{termin.zeit}}<br>Ort: {{termin.ort}}</p>';
export const MAIL_TEMPLATES = {
    'ticket-acknowledgement': {
        label: 'Eingangsbestätigung (E-Mail-Anfrage)',
        group: 'Tickets (Kunden)',
        description: 'Antwort auf eine neue Anfrage per E-Mail',
        groups: CUSTOMER_TICKET,
        requiredInSubject: ['ticket.nummer'],
        defaultSubject: '[{{ticket.nummer}}] Ihre Anfrage: {{ticket.betreff}}',
        defaultBody: T([
            'vielen Dank für Ihre Nachricht. Wir haben Ihre Anfrage unter der Nummer {{ticket.nummer}} aufgenommen und melden uns so bald wie möglich.',
            'Wenn Sie etwas ergänzen möchten, antworten Sie einfach auf diese E-Mail und lassen Sie die Nummer im Betreff stehen.',
        ], '<p>{{schaltflaeche}}</p>'),
    },
    'ticket-reply': {
        label: 'Antwort an den Kunden',
        group: 'Tickets (Kunden)',
        description: 'Öffentliche Antwort eines Mitarbeiters im Ticket',
        groups: CUSTOMER_TICKET,
        requiredInSubject: ['ticket.nummer'],
        defaultSubject: '[{{ticket.nummer}}] Neue Antwort: {{ticket.betreff}}',
        defaultBody: T(['zu Ihrer Anfrage {{ticket.nummer}} „{{ticket.betreff}}“ gibt es eine neue Nachricht:'], '<p>{{nachricht}}</p><p>{{schaltflaeche}}</p>'),
    },
    'ticket-status': {
        label: 'Statusänderung',
        group: 'Tickets (Kunden)',
        description: 'Der Status der Anfrage hat sich (für den Kunden sichtbar) geändert',
        groups: CUSTOMER_TICKET,
        requiredInSubject: ['ticket.nummer'],
        defaultSubject: '[{{ticket.nummer}}] Status: {{ticket.status}}',
        defaultBody: T(['der Status Ihrer Anfrage {{ticket.nummer}} „{{ticket.betreff}}“ hat sich geändert: {{ticket.status}}.'], '<p>{{schaltflaeche}}</p>'),
    },
    'ticket-guest-code': {
        alwaysSent: true,
        label: 'Einmalcode (Anfrage ohne Konto)',
        group: 'Tickets (Kunden)',
        description: 'Code zum Öffnen einer Anfrage über den Link ohne Kundenkonto',
        groups: ['Ticket'],
        required: ['code'],
        defaultSubject: 'Ihr Code für Anfrage {{ticket.nummer}}',
        defaultBody: T(['Ihr Code zum Ansehen und Beantworten der Anfrage {{ticket.nummer}} lautet:', '<strong>{{code}}</strong>', 'Der Code ist {{gueltigkeit}} gültig. Wenn Sie ihn nicht angefordert haben, ignorieren Sie diese E-Mail.']),
    },
    'repair-guest-code': {
        alwaysSent: true,
        label: 'Einmalcode (Reparatur ohne Konto)',
        group: 'Reparaturen (Kunden)',
        description: 'Code zum Öffnen einer Reparatur über den Link ohne Kundenkonto',
        groups: ['Reparatur'],
        required: ['code'],
        defaultSubject: 'Ihr Code für Reparatur {{reparatur.nummer}}',
        defaultBody: T(['Ihr Code zum Ansehen der Reparatur {{reparatur.nummer}} lautet:', '<strong>{{code}}</strong>', 'Der Code ist {{gueltigkeit}} gültig. Wenn Sie ihn nicht angefordert haben, ignorieren Sie diese E-Mail.']),
    },
    'repair-received': {
        label: 'Gerät angenommen',
        group: 'Reparaturen (Kunden)',
        description: 'Annahmebestätigung einer Reparatur',
        groups: CUSTOMER_REPAIR,
        defaultSubject: 'Ihr Gerät ist bei uns eingegangen ({{reparatur.nummer}})',
        defaultBody: T(['wir haben Ihr Gerät ({{reparatur.geraet}}) unter der Reparaturnummer {{reparatur.nummer}} angenommen. Über den Fortschritt halten wir Sie auf dem Laufenden.'], '<p>{{schaltflaeche}}</p>'),
    },
    'repair-status': {
        label: 'Neuer Reparaturstand',
        group: 'Reparaturen (Kunden)',
        description: 'Der Stand der Reparatur hat sich geändert',
        groups: CUSTOMER_REPAIR,
        defaultSubject: 'Reparatur {{reparatur.nummer}}: {{reparatur.status}}',
        defaultBody: T(['der Stand Ihrer Reparatur {{reparatur.nummer}} hat sich geändert: {{reparatur.status}}.'], '<p>{{schaltflaeche}}</p>'),
    },
    'repair-ready': {
        label: 'Gerät abholbereit',
        group: 'Reparaturen (Kunden)',
        description: 'Das Gerät kann abgeholt werden',
        groups: CUSTOMER_REPAIR,
        defaultSubject: 'Ihr Gerät ist abholbereit ({{reparatur.nummer}})',
        defaultBody: T(['Ihr Gerät ({{reparatur.geraet}}, Reparatur {{reparatur.nummer}}) ist abholbereit. Bitte bringen Sie zur Abholung Ihren Annahmeschein oder die Reparaturnummer mit.'], '<p>{{schaltflaeche}}</p>'),
    },
    'repair-quote': {
        label: 'Kostenvoranschlag',
        group: 'Reparaturen (Kunden)',
        description: 'Kostenvoranschlag zur Freigabe (PDF im Anhang)',
        groups: CUSTOMER_REPAIR,
        defaultSubject: 'Kostenvoranschlag zu Ihrer Reparatur {{reparatur.nummer}}',
        defaultBody: T(['für die Reparatur {{reparatur.nummer}} ({{reparatur.geraet}}) haben wir einen Kostenvoranschlag über {{kva.betrag}} erstellt.', 'Bitte geben Sie ihn im Kundenportal frei oder lehnen Sie ihn ab. Gerne können Sie uns auch anrufen.'], '<p>{{schaltflaeche}}</p>'),
    },
    'appointment-scheduled': { label: 'Terminbestätigung', group: 'Termine (Kunden)', description: 'Neuer Termin', groups: APPOINTMENT, defaultSubject: 'Terminbestätigung: {{termin.titel}}', defaultBody: T(['wir bestätigen folgenden Termin:'], TERMIN_DETAILS) },
    'appointment-rescheduled': { label: 'Termin verschoben', group: 'Termine (Kunden)', description: 'Geänderter Termin', groups: APPOINTMENT, defaultSubject: 'Ihr Termin wurde verschoben: {{termin.titel}}', defaultBody: T(['wir bestätigen folgenden Termin:'], TERMIN_DETAILS) },
    'appointment-cancelled': { label: 'Termin abgesagt', group: 'Termine (Kunden)', description: 'Abgesagter Termin', groups: APPOINTMENT, defaultSubject: 'Ihr Termin wurde abgesagt: {{termin.titel}}', defaultBody: T(['der folgende Termin findet leider nicht statt:'], TERMIN_DETAILS) },
    'appointment-reminder': { label: 'Terminerinnerung', group: 'Termine (Kunden)', description: 'Erinnerung vor dem Termin', groups: APPOINTMENT, defaultSubject: 'Erinnerung an Ihren Termin: {{termin.titel}}', defaultBody: T(['wir erinnern Sie an folgenden Termin:'], TERMIN_DETAILS) },
    'form-confirm': { label: 'Formular: Bestätigung', group: 'Formulare und Verträge', description: 'Bestätigung eines Online-Formulars', groups: ['Ticket'], defaultSubject: '{{betreff}}', defaultBody: GENERIC },
    'contract-document': { label: 'Vertragsdokument', group: 'Formulare und Verträge', description: 'Vertrag als PDF an den Kunden', groups: ['Kunde'], defaultSubject: '{{betreff}}', defaultBody: GENERIC },
    invitation: {
        alwaysSent: true,
        label: 'Einladung',
        group: 'Zugang',
        description: 'Neuer Zugang (Mitarbeiter oder Kundenportal)',
        groups: ['Zugang'],
        required: ['link'],
        defaultSubject: 'Einladung zum Serviceportal – {{firma.name}}',
        defaultBody: T(['für Sie wurde ein Zugang zum Serviceportal von {{firma.name}} angelegt.', 'Bitte legen Sie über den folgenden Link Ihr Passwort fest. Der Link ist {{gueltigkeit}} gültig.'], '<p>{{schaltflaeche}}</p>'),
    },
    'password-reset': {
        alwaysSent: true,
        label: 'Passwort zurücksetzen',
        group: 'Zugang',
        description: '„Passwort vergessen“',
        groups: ['Zugang'],
        required: ['link'],
        defaultSubject: 'Passwort zurücksetzen – {{firma.name}}',
        defaultBody: T(['es wurde angefordert, das Passwort Ihres Zugangs zurückzusetzen.', 'Der Link ist {{gueltigkeit}} gültig. Wenn Sie das nicht angefordert haben, ignorieren Sie diese E-Mail.'], '<p>{{schaltflaeche}}</p>'),
    },
    'email-verification': {
        alwaysSent: true,
        label: 'E-Mail-Adresse bestätigen',
        group: 'Zugang',
        description: 'Bestätigung nach Registrierung oder Adressänderung',
        groups: ['Zugang'],
        required: ['link'],
        defaultSubject: 'E-Mail-Adresse bestätigen – {{firma.name}}',
        defaultBody: T(['bitte bestätigen Sie Ihre E-Mail-Adresse. Der Link ist {{gueltigkeit}} gültig.'], '<p>{{schaltflaeche}}</p>'),
    },
    'ticket-assigned': { label: 'Ticket zugewiesen (an Bearbeiter)', group: 'Intern', description: 'Jemand hat Ihnen ein Ticket zugewiesen', groups: CUSTOMER_TICKET, defaultSubject: '{{betreff}}', defaultBody: GENERIC },
    'ticket-customer-reply': { label: 'Kundenantwort (an Bearbeiter)', group: 'Intern', description: 'Kunde hat geantwortet', groups: CUSTOMER_TICKET, defaultSubject: '{{betreff}}', defaultBody: GENERIC },
    'ticket-watcher': { label: 'Beteiligte: neue Nachricht/Status', group: 'Intern', description: 'An Beteiligte eines Tickets', groups: CUSTOMER_TICKET, defaultSubject: '{{betreff}}', defaultBody: GENERIC },
    'repair-quote-decision': { label: 'KVA-Entscheidung (an Techniker)', group: 'Intern', description: 'Kunde hat den Kostenvoranschlag entschieden', groups: CUSTOMER_REPAIR, defaultSubject: '{{betreff}}', defaultBody: GENERIC },
    'repair-cost-exceeded': { label: 'Kosten über KVA (an Techniker)', group: 'Intern', description: 'Der tatsächliche Aufwand übersteigt den freigegebenen Kostenvoranschlag bzw. die Kostenfreigabe', groups: CUSTOMER_REPAIR, defaultSubject: '{{betreff}}', defaultBody: GENERIC },
    'billing-returned': { label: 'Rückfrage der Buchhaltung', group: 'Intern', description: 'Vorgang an die Technik zurückgegeben', groups: ['Ticket', 'Mitarbeiter'], defaultSubject: '{{betreff}}', defaultBody: GENERIC },
    'billing-change-request': { label: 'Änderungsantrag (an Buchhaltung)', group: 'Intern', description: 'Techniker beantragt Änderung', groups: ['Mitarbeiter'], defaultSubject: '{{betreff}}', defaultBody: GENERIC },
    'billing-change-decision': { label: 'Entscheidung Änderungsantrag', group: 'Intern', description: 'Antwort der Buchhaltung', groups: ['Mitarbeiter'], defaultSubject: '{{betreff}}', defaultBody: GENERIC },
    'form-received': { label: 'Formular eingegangen (intern)', group: 'Intern', description: 'Neue Formulareinsendung', groups: ['Ticket'], defaultSubject: '{{betreff}}', defaultBody: GENERIC },
    'monitoring-ticket': { label: 'Monitoring-Ticket (intern)', group: 'Intern', description: 'Ticket aus Zabbix/NetDoc', groups: ['Ticket', 'Kunde'], defaultSubject: '{{betreff}}', defaultBody: GENERIC },
};
export const MAIL_TEMPLATE_KEYS = Object.keys(MAIL_TEMPLATES);
/** Variablen, die in einer Vorlage verfügbar sind */
export function templateVariables(key) {
    const groups = new Set(['Allgemein', ...MAIL_TEMPLATES[key].groups]);
    return Object.keys(MAIL_VARIABLES).filter((v) => groups.has(MAIL_VARIABLES[v].group));
}
const VAR_RE = /\{\{\s*([a-z.]+)\s*\}\}/g;
export const usedVariables = (s) => [...s.matchAll(VAR_RE)].map((m) => m[1]);
export const mailTemplateSchema = z.object({
    subject: z.string().trim().min(1).max(300),
    bodyHtml: z.string().max(100_000),
    active: z.boolean().default(true),
});
export const mailLayoutSchema = z.object({
    primaryColor: z.string().regex(/^#[0-9a-fA-F]{6}$/).nullish(),
    backgroundColor: z.string().regex(/^#[0-9a-fA-F]{6}$/).default('#f8fafc'),
    textColor: z.string().regex(/^#[0-9a-fA-F]{6}$/).default('#0f172a'),
    fontFamily: z.enum(['system', 'arial', 'georgia', 'verdana', 'tahoma']).default('system'),
    showLogo: z.boolean().default(true),
    headerHtml: z.string().max(20_000).default(''),
    footerHtml: z.string().max(20_000).default(''),
    signatureHtml: z.string().max(20_000).default(''),
});
export const MAIL_FONTS = {
    system: { label: 'Systemschrift', css: "system-ui,-apple-system,'Segoe UI',Roboto,Arial,sans-serif" },
    arial: { label: 'Arial', css: 'Arial,Helvetica,sans-serif' },
    georgia: { label: 'Georgia', css: "Georgia,'Times New Roman',serif" },
    verdana: { label: 'Verdana', css: 'Verdana,Geneva,sans-serif' },
    tahoma: { label: 'Tahoma', css: 'Tahoma,Geneva,sans-serif' },
};
/** Kann der Mandant den Versand dieser Mail-Art abschalten? (Zugangs- und Code-Mails nie) */
export function canDisableMail(key) {
    const def = MAIL_TEMPLATES[key];
    return Boolean(def) && !def.alwaysSent;
}
//# sourceMappingURL=mail-templates.js.map